<template>
  <div class="chat-cards">
      <el-row :gutter="20">
          <el-col :span="8" v-for="(card, index) in cards" :key="index">
              <el-card>
                  <div class="card-content">
                      <div class="icon" :class="card.icon"></div>
                      <div class="info">
                          <h3>{{ card.value }}</h3>
                          <p>{{ card.title }}</p>
                          <span :class="card.change > 0 ? 'positive' : 'negative'">
                              {{ card.change > 0 ? '+' : '' }}{{ card.change }}%
                          </span>
                      </div>
                  </div>
              </el-card>
          </el-col>
      </el-row>
  </div>
</template>

<script>
export default {
  props: {
      cards: {
          type: Array,
          required: true,
      },
  },
};
</script>

<style scoped>
.chat-cards .el-card {
  background: #ffffff;
  color: #212529;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-content {
  display: flex;
  align-items: center;
}

.card-content .icon {
  font-size: 30px;
  margin-right: 20px;
}

.card-content .positive {
  color: #28a745;
}

.card-content .negative {
  color: #dc3545;
}

@media (max-width: 768px) {
  .el-card {
      margin-bottom: 20px;
  }
}
</style>
